import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideState, provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideNativeDateAdapter } from '@angular/material/core';
import { CookieConfig, ProvideCookiesNgrx } from '@teamfoster/sdk/cookie-ngrx';
import { ProvideDictionaryNgrx } from '@teamfoster/sdk/dictionary-ngrx';
import { ProvideIcons } from '@teamfoster/sdk/icon';
import { ImageSharpConfig, ProvideOptimisedImageProcessor } from '@teamfoster/sdk/image';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';
import { reducers, metaReducers, appEffects, CustomSerializer } from './store';
import * as fromContent from './content/store';
import { ProvideContentNgrx } from './content/content.providers';
import { ProvideBlogsNgrx } from './blogs/blogs.providers';
import { ProvideDiseaseProfilesNgrx } from './disease-profiles/disease-profiles.providers';
import { ProvideMemberFormNgrx } from './member-form/member-form.providers';
import { ProvideSearchNgrx } from './search/search.providers';
import { ProvideSettingsNgrx } from './settings/settings.providers';
import { registerLocaleData } from '@angular/common';

import localeNl from './nl';

const cookieConfig: CookieConfig = {
  analyticsCode: 'G-L8T44BPQDT',
  strippedContentPlaceholder: 'Deze inhoud wordt niet getoond omdat je geen cookies hebt geaccepteerd',
  types: {
    analytical: true,
    functional: true,
    marketing: true,
  },
  showSettings: true,
};

registerLocaleData(localeNl, 'nl');

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' })
    ),
    provideStore(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    provideEffects(appEffects),
    provideRouterStore({ serializer: CustomSerializer }),
    provideStoreDevtools({ maxAge: 25, logOnly: environment.production }),
    ProvideDictionaryNgrx({}),
    ProvideIcons({ spritesheetUrl: 'assets/gfx/svg-sprite.svg' }),
    ProvideCookiesNgrx(cookieConfig),
    ProvideContentNgrx(),
    ProvideBlogsNgrx(),
    ProvideDiseaseProfilesNgrx(),
    ProvideMemberFormNgrx(),
    ProvideSearchNgrx(),
    ProvideSettingsNgrx(),
    ProvideOptimisedImageProcessor(ImageSharpConfig, {
      defaultFormat: 'webp',
    }),
    provideClientHydration(withNoIncrementalHydration()),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideZoneChangeDetection(),
    provideNativeDateAdapter(),
    { provide: LOCALE_ID, useValue: 'nl' },
  ],
};
